import { useEffect } from "react"; 
import { useSocketStore } from "../../stores/useSocketStore";
import { useChegadasViagensStore } from "../../stores/useChegadasViagensStore";

export function useChegadasViagensSocket() {

    const socket = useSocketStore(state => state.socket);

    useEffect(() => {
        
        if (!socket)
            return;

        const {
            upsertChegada,
            removeChegada
        } = useChegadasViagensStore.getState();

        socket.on('chegadasViagens:upserted', upsertChegada);

        socket.on('chegadasViagens:deleted', removeChegada);

        return () => {
            
            socket.off('chegadasViagens:upserted', upsertChegada);

            socket.off('chegadasViagens:deleted', removeChegada);

        };

    }, [socket]);

}